import React from 'react';
// import './button.css';

const BtnLogin = React.memo((props) => {
    return (
        <button className={`invest_btn sunbtn ${props.class} ${props.btnloader ? "spin" : ""}`}
            onClick={() => props.onClick()}
            disabled={props.btnloader ? true : false}
        > {props.name} {props.btnloader ? <span className="spinner"></span> : null}</button >
    )
})

export default BtnLogin